import { useCallback, useState } from 'react';
import { Footer } from 'src/App/Components/Footer/Footer';
import { Header } from 'src/App/Components/Header/Header';
import { Commands } from './Commands/Commands';
import { HomeContain, HomeTabWrapper, HomeTabItem, HomeTabSeparator, HomeTabTxt } from './Home.styles';
import { Leaderboard } from './Leaderboard/Leaderboard';
import Images from 'src/App/Images';
import { useAppSelector } from 'src/App/redux/hooks';
import { RootState } from 'src/App/redux/store';
import { HomeTabNames, HomeTabs } from 'src/App/Types/app.types';

export function Home() {
	const tabOrder = useAppSelector((state: RootState) => state.app.tab_order ?? [HomeTabs.COMMANDS, HomeTabs.HFX, HomeTabs.LEADERBOARD]);
	const [tab, setTab] = useState(tabOrder[0]);
	const [title, setTitle] = useState("Take control of your favorite streamer's setup");

	const handleTitleChange = useCallback(
		(newTitle) => {
			setTitle(newTitle);
		},
		[setTitle],
	);

	return (
		<HomeContain>
			<Header />
			<HomeTabWrapper>
				{tabOrder.map((tabSelection, idx) => (
					<>
						{idx !== 0 && <HomeTabSeparator />}
						<HomeTabItem selected={tab === tabSelection} onClick={() => setTab(tabSelection)}>
							{tabSelection === HomeTabs.HFX ? <Images.Hfx /> : tabSelection === HomeTabs.COMMANDS ? <Images.CommandIcon /> : <Images.LeaderboardIcon />}
							<HomeTabTxt>{HomeTabNames[tabSelection]}</HomeTabTxt>
						</HomeTabItem>
					</>
				))}
			</HomeTabWrapper>
			<>
				{tab === HomeTabs.COMMANDS ? (
					<Commands type="commands" changeTitle={handleTitleChange} />
				) : tab === HomeTabs.HFX ? (
					<Commands type="hfx" changeTitle={handleTitleChange} />
				) : (
					<Leaderboard changeTitle={handleTitleChange} />
				)}
			</>
			<Footer title={title} />
		</HomeContain>
	);
}
